import { http } from "./http";

const CENSUS_SHOPS_ROUTE_NAME = "census_shops";

const Services = {
	getTenantUniqueCensusKeys: async ({ tenantName }) => {
		return http.get(`/${CENSUS_SHOPS_ROUTE_NAME}/getTenantUniqueCensusKeys/${tenantName}`);
	},
	getKeyUniqueValues: async ({ tenantName, key }) => {
		return http.get(`/${CENSUS_SHOPS_ROUTE_NAME}/getKeyUniqueValues/${tenantName}/${key}`);
	},
	getCensusShopDetails: async ({ shopId, keysToFetch }) => {
		return http.get(`/${CENSUS_SHOPS_ROUTE_NAME}/getCensusShopDetails`, {
			params: { shopId, keysToFetch }
		});
	},

	getAllTenantShopForScoring: async ({ tenantName, keysToFetch }) => {
		return http.get(`/${CENSUS_SHOPS_ROUTE_NAME}/getAllTenantShopForScoring`, {
			params: { tenantName, keysToFetch }
		});
	},
	fetchCensusShops: async ({ params }) => {
		return http.post(`/${CENSUS_SHOPS_ROUTE_NAME}/fetchCensusShops`, {
			...params
		});
	}
};

export default Services;
